import { render, staticRenderFns } from "./release-help-dialog.component.vue?vue&type=template&id=335061b0&scoped=true&"
import script from "./release-help-dialog.component.vue?vue&type=script&lang=ts&"
export * from "./release-help-dialog.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335061b0",
  null
  
)

export default component.exports